export const Filters = {
    ALL: 'all',
    TODAY: 'today',
    FUTURE: 'future',
    ACTUAL: 'actual',
    DAY: 'day',
    CATEGORY: 'category'
};